import { MODE_TEMPATES } from '@constants';
import { Button, App } from 'antd';
import { useState } from 'react';
import { IFileInfo } from 'react-csv-reader';
import { Trans, useTranslation } from 'react-i18next';

import {
  DescriptionWrapper,
  FileInfoWrapper,
  FileWrapper,
  IconWrapper,
  InfoWrapper,
  ItemWrapper,
  LinkWrapper,
  TextWrapper,
  TitleWrapper,
  Wrapper
} from './ImportCsvOption.styles';
import { ImportInstructions } from './ImportInstructions';

import { CsvReader } from '@/components/CsvReader';
import { Icon } from '@/components/Icon';
import { useQuizForm } from '@/hooks';
import { mapQuizCsvData } from '@/utils';
import { checkCsvData } from '@/utils/checkCsvData';

export const ImportCsvOption = () => {
  const { message } = App.useApp();
  const { t } = useTranslation('ManagerQuizzesTranslations');
  const { config, setIsInstructionsOpen, isInstructionsOpen, setQuestions, setQuizDescription } =
    useQuizForm();
  const [fileInfo, setFileInfo] = useState<IFileInfo | null>(null);

  const handleOpenTemplate = () => {
    if (config?.mode) return window.open(MODE_TEMPATES[config.mode], '_blank');
    return;
  };

  const handleUpload = (formData: { [key: string]: string }[], dataInfo: IFileInfo) => {
    if (!config?.mode) return message.error(t('IMPORT_CSV_ERROR_MESSAGE'));
    const isValid = checkCsvData(formData, config.mode);
    if (!isValid) return message.error(t('IMPORT_CSV_ERROR_MESSAGE'));
    setFileInfo(dataInfo);
    const { questions, description } = mapQuizCsvData(formData, config.mode, t);
    setQuestions(questions);
    setQuizDescription(description);
    return;
  };

  if (isInstructionsOpen) return <ImportInstructions />;

  return (
    <Wrapper>
      <ItemWrapper>
        1.
        <InfoWrapper>
          <TextWrapper>
            <TitleWrapper>{t('COMPLETE_THE_TEMPLATE')}</TitleWrapper>
            <DescriptionWrapper>
              <Trans
                i18nKey="ManagerQuizzesTranslations:COMPLETE_THE_TEMPLATE_DESCRIPTION"
                components={{ a: <LinkWrapper onClick={() => setIsInstructionsOpen(true)} /> }}
              />
            </DescriptionWrapper>
          </TextWrapper>
          <Button onClick={handleOpenTemplate}>{t('OPEN_TEMPLATE')}</Button>
        </InfoWrapper>
      </ItemWrapper>
      <ItemWrapper>
        2.
        <InfoWrapper>
          <TextWrapper>
            <TitleWrapper>{t('UPLOAD_CSV_FILE')}</TitleWrapper>
          </TextWrapper>
          {fileInfo ? (
            <FileWrapper>
              <FileInfoWrapper>
                <IconWrapper>
                  <Icon i="DocumentWordProcessor" />
                </IconWrapper>
                <div>{fileInfo.name}</div>
              </FileInfoWrapper>
              <Button type="text" size="small" onClick={() => setFileInfo(null)}>
                <Icon i="TrashCan" />
              </Button>
            </FileWrapper>
          ) : (
            <CsvReader fileLoaded={handleUpload} disabled={false} />
          )}
        </InfoWrapper>
      </ItemWrapper>
    </Wrapper>
  );
};
